module.exports = __webpack_public_path__ + "img/MAY DAY.fb4e0c1.svg";